import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { getStyle } from '../../../../styles/styles';
import { formatValidInput } from '../../../../helpers/FormatHelper';
import AlertBox from '../../../shared/AlertBox';
import { validate } from '../../../../helpers/ValidateHelper';
import { getNewBeneficiaryEmail } from '../../../../networking/NetworkingBeneficiaries';

var style = getStyle();
const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

export default class DialogBeneficiaryInvitation extends React.Component {
    state = {
        email: '',
        beneficiaryName: '',
        validations: {
            email: true,
            beneficiaryName: true
        },
        showAlert: false,
        showAlertResponse: false,
        alertMessage: '',
        alertTitle: ''
    }
    componentDidMount() {
        this.validateRequiredInputs();
    }
    handleUpdateBeneficiaryName = (event) => {
        this.setState({
            beneficiaryName: event.target.value,
            validations: { ...this.state.validations, beneficiaryName: true }
        }, () => this.validateRequiredInputs());
    }
    handleUpdateEmail = (event) => {
        this.setState({
            email: event.target.value,
            validations: { ...this.state.validations, email: true }
        }, () => this.validateRequiredInputs());
    }
    validateRequiredInputs = () => {
        let fields = [
            { displayName: 'Beneficiary Name', validateName: 'beneficiaryName', value: this.state.beneficiaryName, type: 'string' },
            { displayName: 'Email', validateName: 'email', value: this.state.email, type: 'email' }
        ];
        const [valid, validations, errors] = validate(fields);
        this.setState({ valid, errors })
        return { valid, errors };
    }
    validateRequiredFields = () => {
        let fields = [
            { displayName: 'Beneficiary Name', validateName: 'beneficiaryName', value: this.state.beneficiaryName, type: 'string' },
            { displayName: 'Email', validateName: 'email', value: this.state.email, type: 'email' }
        ];
        const [valid, validations, errors] = validate(fields);
        this.setState({ validations, errors })
        return { validations, errors };
    }
    handleSendMailClick = () => {
        let beneName=this.props.beneName;
        let beneEmail=this.props.beneEmail;        
        this.setState({ 
            beneficiaryName: beneName, 
            email: beneEmail
        });
        getNewBeneficiaryEmail(this.props.id, this.props.PersonID, beneName, beneEmail).then(
            (json) => {
                if (json.httpStatusCode !== 200) {
                    this.setState({ showAlertResponse: true, alertTitle: 'Error', alertMessage: 'An error occurred while trying to send email. Please try again..' })
                } else {
                    this.setState({ showAlertResponse: true, alertTitle: 'Success', alertMessage: 'Send Beneficiary invitation successfully.' });
                }
            }
        );
    }
    clearData = () => {
        this.setState({
            beneficiaryName: '',
            email: '',
            validations: {
                email: true,
                beneficiaryName: true
            },
            showAlert: false,
            alertMessage: '',
            alertTitle: ''
        });
    }
    closeAlert = () => {
        this.setState({ showAlert: false, alertMessage: '', alertTitle: '' })
    }
    closeAlertResponse = () => {
        this.setState({ showAlertResponse: false, alertMessage: '', alertTitle: '' }, this.closeDialog())
    }
    closeDialog = () => {
        this.clearData();
        this.props.close();
    }
    render() {
        return (
            <Dialog open={this.props.open} onClose={this.closeDialog} aria-labelledby={'messageConfirmInvitationTitle'} aria-describedby={'messageConfirmInvitationBy'}>
                <DialogTitle key="title-bene-invitation" id={"title-bene-invitation"}>{"Warning"}</DialogTitle>
                <hr style={{ margin: '0px' }} />
                <DialogContent key="content">
                    <DialogContentText id={'messageConfirmInvitation'}>
                        {"Do you want to send a request to register their bank account information?"}
                    </DialogContentText>
                    <div className="uk-width-1-1">
                        <div>
                        <label className="uk-form-label uk-width-1-2 " >Beneficiary:</label>
                        <div className="uk-form-controls uk-width-1-2 " >{this.props.beneName}</div>
                        <label className="uk-form-label uk-width-1-2 " >Email:</label>
                        <div className="uk-form-controls uk-width-1-2 " >{this.props.beneEmail}</div>
                        </div>
                    </div>
                </DialogContent>
                <hr style={{ margin: '0px' }} />
                <DialogActions>
                    <button className="uk-button uk-button-green uk-margin-right" onClick={this.handleSendMailClick} type="button">Yes</button>
                    <button className="uk-button uk-button-green uk-margin-right" onClick={this.closeDialog} type="button">No</button>
                </DialogActions>
            <AlertBox open={this.state.showAlert} onClose={this.closeAlert} title={this.state.alertTitle} messageBoldList={this.state.errors} message={this.state.alertMessage} type="Ok" okClick={this.closeAlert} />
            <AlertBox open={this.state.showAlertResponse} onClose={this.closeAlertResponse} title={this.state.alertTitle} message={this.state.alertMessage} type="Ok" okClick={this.closeAlertResponse} />
            </Dialog>
        );
    }
}